import React from 'react';
import {useDispatch} from "react-redux";
import IntlMessage from "../../../../components/IntlMessage/IntlMessage";
import {Flex, Tabs} from "antd";
import MyText from "../../../../components/UI/Text/MyText";
import GroupsList from "./List/GroupsList";
import CreationGroups from "./Creation/CreationGroups";

const GroupsPage = () => {
    const dispatch = useDispatch();
    const onChangeTabs = async (key) => {
        if (key === '1') {

        }
    };
    const tabItems = [
        {
            key: '1',
            label: <IntlMessage id={'list'}/>,
            children: <GroupsList/>,
        },
        {
            key: '2',
            label: <IntlMessage id={'create'}/>,
            children: <CreationGroups/>,
        },
    ]

    return (
        <Flex style={{width: "100%"}} align={"flex-start"} justify={"flex-start"} vertical gap={20}>
            <MyText uppercase strong size={"large"}><IntlMessage id={'ordersPage.groups'}/></MyText>
            <Tabs style={{width: "100%"}} defaultActiveKey={"1"} type="card" items={tabItems} onChange={onChangeTabs}/>
        </Flex>
    );
};

export default GroupsPage;